// @ts-nocheck
import { useTranslation } from "react-i18next";

import _ from "lodash";
import Schemas from "schemas";

import PopUpWrapper from "./modal-wrapper";

import { Control } from "components/ui-kit/control";
import { Button, Form, Row } from "components/ui-kit/styled-templates";
import moment from "moment-timezone";
import { CURRENCIES, EVENT_TYPES_OPTIONS } from "constants/config";
import OECDs from "constants/OECDs.json";

import EventsApi from "api/events-api";

import useFormControl from "hooks/useFormControl";
import useModal from "hooks/useModal";

import { EForms, EModals, ERoles } from "types/enums";
import VisibilitySwitcher from "../auxiliary/tools/VisibilitySwitcher";
import { useEffect } from "react";
import ClubsApi from "../../api/clubs-api";
import { useStorageListener } from "../../hooks/useStorage";

const EditEventModal = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language == "ru";

    // @ts-ignore
    useEffect(ClubsApi.getMyClubs, []);

    const clubs = useStorageListener(
        (state) => _.values(state?.clubs)?.filter?.((i: any) => i?.universityId === state?.myUniversityId) ?? []
    );

    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);

    const { data: formData, onSubmit, clearForm, setValues } = useFormControl({
        name: EForms.editEvent,
        schema: Schemas[EForms.editEvent]
    });
    const { close, state: modalState = {} } = useModal(EModals.CreateEvent, {
        onOpen: ({ data = {} }: any) => setValues(data?.details ?? {})
    });
    const { mode, data } = modalState;

    const anyChanges = !_.isEqual(data?.details, formData);

    const handlers = {
        submit: async (details: any) => {
            let fixedDetails = {
                ...details
            }
            if (fixedDetails.dates != undefined){
                if (fixedDetails.dates.from != undefined){
                    fixedDetails.dates.from = +moment(+fixedDetails.dates.from).startOf('day') + 12 * 60 * 60 * 1000; // add 12h shift
                }
                if (fixedDetails.dates.to != undefined){
                    fixedDetails.dates.to = +moment(+fixedDetails.dates.to).startOf('day') + 12 * 60 * 60 * 1000; // add 12h shift
                }
            }
            if (mode === `create`) {
                await EventsApi.createEvent(details);
            } else {
                await EventsApi.updateEvent({ ...data, details: fixedDetails });
            }
            close();
        }
    };

    useEffect(() => {
        if (`${role}`.indexOf("clu") > -1) {
            setValues({ ...formData, type: "active_tourism" });
        }
    }, [role]);

    let isAlwaysAvailable = (formData?.isAlwaysAvailable == undefined ? false : formData?.isAlwaysAvailable);
    console.log("--->>> isAlwaysAvailable = ", isAlwaysAvailable);
    console.log("--->>> clubs = ", clubs);
    let clubsOptions = clubs.map((i) => {
        return {
            value: i?.id,
            label: i?.details?.name
        };
    });

    let typesOptions = EVENT_TYPES_OPTIONS;


    return (
        <PopUpWrapper name={EModals.CreateEvent} onClose={clearForm}>
            <Form name={EForms.editEvent} onSubmit={onSubmit(handlers.submit)} extra={`h3 { margin-top: 0; };`}>
                <h3>{mode === `edit` ? `Редактирование события` : `Добавить событие`}</h3>
                <Control.Row>
                    <Control.TagsSelect value={formData.type} label={t("3pbmz8ywod1")} options={EVENT_TYPES_OPTIONS}
                                        isRequired
                                        onChange={evt => {
                                            console.log("evt = ", evt);
                                            let newType = evt.target.value;
                                            if (`${role}`.indexOf("clu") > -1 && newType != "active_tourism") {
                                                return window.alert("Вы можете создавать только мероприятия активного туризма");
                                            }
                                            setValues({ ...formData, type: newType });
                                        }} />
                </Control.Row>

                <Control.Row>
                    <Control.Input name="name" label={t("zbbidiulvqn")} placeholder={t("nytfzsnt4k")} isRequired />
                </Control.Row>

                {(clubs == undefined || clubs.length == 0 || formData.type != "active_tourism") ? null :
                    <>
                        <Control.Row>
                            <Control.Select
                                name="clubId"
                                label={"Студтурклуб"}
                                options={clubsOptions}
                            />
                        </Control.Row>
                    </>
                }

                <Control.Row>
                    <div style={{ flex: 1, marginBottom: 15 }}>
                        <Control.Switch name="isAlwaysAvailable" label={"Доступно всегда"}
                                        extra="justify-content: flex-start; flex: 2;" />
                    </div>
                </Control.Row>

                {formData.isAlwaysAvailable == true ? null :
                    <div style={{ opacity: (isAlwaysAvailable == false ? 1 : 0.5) }}>
                        <Control.Row>
                            <Control.Date name="dates.from" label={t("1k0xyrjxhpi")} placeholder={t("i6fk86qe16n")}
                                           />

                            <Control.Date name="dates.to" label={t("lnj9a7q1lop")} placeholder={t("rq7coctvhnn")}
                                           />
                            {/*<Control.Switch name="dates.isRegular" label="Регулярное" extra="justify-content: flex-start;" />*/}
                        </Control.Row>
                    </div>
                }

                {/*{formData.isAlwaysAvailable == true ? null :*/}
                {/*    <div style={{ opacity: (isAlwaysAvailable == false ? 1 : 0.5) }}>*/}
                {/*       */}
                {/*    </div>*/}
                {/*}*/}

                <Control.Row>
                    <Control.Input name="from_time"
                                   label={isRu ? "Время начала" : `Time of the start`}
                                   placeholder={isRu ? "пример - 12:00" : `Example - 12:00`} />

                </Control.Row>

                <Control.Row>

                    <Control.Input name="price" extra={`flex: 3;`} label={t("36cwy19cahs")}
                                   placeholder={t("w43xh46j08")} regex="[^0-9]"
                                   isRequired />

                    <Control.Select name="currency" extra={`flex: 3;`} label={"Валюта"}
                                    options={CURRENCIES.map((i) => ({ value: i, label: i }))} isRequired />

                    <Control.Switch name="isFree" label={t("b6cio60ug9a")}
                                    extra="justify-content: flex-start; flex: 2;" />

                </Control.Row>
                <Control.Textarea name="description" placeholder={t("0s9u9ipu171b")} label={t("gs1plnr6trc")}
                                  isRequired />

                {formData.type != "active_tourism" ? null :
                    <Control.Textarea name="additionalInformation" placeholder={"Дополнительная информация"}
                                      label={"Дополнительная информация"} />
                }
                {formData.type != "active_tourism" ? null :
                    <Control.Textarea name="contactsInformation" placeholder={"Контактные данные"}
                                      label={"Контактные данные"} />
                }
                {formData.type != "active_tourism" ? null :
                    <Control.Textarea name="requiredDocumentsInformation"
                                      placeholder={"Перечень необходимых документов и требования"}
                                      label={"Перечень необходимых документов и требования"} />
                }

                <Control.Textarea name="importantInformation" placeholder={"Важная информация"}
                                  label={"Важная информация"} />

                <Control.Input name="link" label={t("7zf8t9xh2n")} placeholder="https://example.com" />

                <Control.File name="photos" label={t("9bvpek1gpn")} multiple isRequired
                              dropzoneProps={{ label: `Загрузить фото (не более 2 МБ, формат JPG, PNG)` }}
                />
                <Control.File
                    name="video"
                    label={t("qhai5sjue4")}
                    accept="video/mp4, video/quicktime"
                    maxFilesNumber={1}
                    multiple
                    dropzoneProps={{ label: `Загрузить видео (не более 50 МБ, .mp4)`, icon: `dropzone-video` }}
                />
                {anyChanges && <Control.Error extra={`margin-bottom: 15px;`}>{t("pmx84aglymk")}</Control.Error>}

                {/*<Control.Checkbox name="hideMyInfo" placeholder={''} label={'Скрыть информацию для всех пользователей, кроме Администратора Платформы'} />*/}

                {data?.id == undefined ? null :
                    <>
                        {/*@ts-ignore*/}
                        <VisibilitySwitcher
                            dbClassName={"StudEvent"}
                            id={data?.id}
                            field={"hideFromAll"}
                        />
                    </>
                }

                <Row extra={`width: inherit; justify-content: flex-end; gap: 10px;`}>
                    <Button variant="outlined" background="gray" onClick={close}>
                        {t("ccau4cdj7rj")}
                    </Button>
                    <Button type="submit" background="green">
                        {t("2hx4fcppcpw")}
                    </Button>
                </Row>
            </Form>
        </PopUpWrapper>
    );
};

export default EditEventModal;
